import EasyTranslate from "../easy-translate";
import { getIsMobile } from "../utils/device";
import { SDKType } from "@shop/entries-types";

const translateEl = document.createElement("div");

const mobileWidth = 767; // 移动端屏幕宽度临界值
const isMobile = getIsMobile(mobileWidth);

// type: 定义全局类型shopSDk
declare global {
  interface Window {
    shopSDK: SDKType;
  }
}

// pc端挂载
async function injectElToBody() {
  const translateElName = "brooklyn_container";

  translateEl.className = translateElName;

  let hasPointer = false;

  await shopSDK.register(["ui-extension-points"], ({ uiExtensionPoints }) => {
    uiExtensionPoints.defineExtComp(["HeaderLinkBarBefore"], (pointer) => {
      if (pointer) {
        hasPointer = true;
      }

      return {
        data() {
          return {};
        },
        render(prevDom) {
          if (!prevDom) {
            translateEl.classList.add("brooklyn_container--ui-pointer");

            return translateEl;
          }

          return prevDom;
        },
      };
    });
  });

  // 挂载点找不到的时候, 这里需要适当延期下
  setTimeout(() => {
    if (!hasPointer) {
      // thank you 页面不挂载
      const { pathname } = location;

      // pathname 是 /order/ 开头的，则为thank you 页面
      if (pathname?.startsWith("/orders/") || pathname?.startsWith("/checkout/")) {
        return;
      }

      document.body.appendChild(translateEl);
    }
  }, 1000);
}

// 移动端挂载
async function injectElToAside() {
  const translateElName = "brooklyn_mobile_container";
  translateEl.className = translateElName;

  let hasPointer = false;

  await shopSDK.register(["ui-extension-points"], ({ uiExtensionPoints }) => {
    uiExtensionPoints.defineExtComp(
      ["HeaderDrawerMenuContentBottom"],
      (pointer) => {
        if (pointer) {
          hasPointer = true;
        }

        return {
          render(prevDom) {
            if (!prevDom) {
              translateEl.classList.add(
                "brooklyn_mobile_container--ui-pointer"
              );

              return translateEl;
            }

            return prevDom;
          },
        };
      }
    );
  });

  // 没有该挂载点
  setTimeout(() => {
    if (!hasPointer) {
      const asideElName = ".side-menu nav";
      const asideEl = document.querySelector(asideElName);

      if (asideEl) {
        asideEl.appendChild(translateEl);
      }
    }
  }, 1000);
}

const translateBrooklyn = function () {
  if (!isMobile) {
    injectElToBody();
    window.et_translate = new EasyTranslate({
      excluded_blocks: [
        ".et-select",
        ".et-select-mobile",
        ".ws-currency-trigger", // 价格
        "ws-price",
        ".checkoutrightbody .shoppingcarlist .price",
        ".checkoutrightbody .computedlist",
        ".checkoutrightbody .computetotal",
        ".checkoutrightbody .computetotalTip span",
      ],
      mount: translateEl,
      isMobile,
    });
  } else {
    injectElToAside();
    window.et_translate = new EasyTranslate({
      excluded_blocks: [
        ".et-select",
        ".et-select-mobile",
        ".ws-currency-trigger", // 价格
        "ws-price",
        ".checkoutrightbody .shoppingcarlist .price",
        ".checkoutrightbody .computedlist span:nth-child(2)",
        ".checkoutrightbody .computetotal>p",
      ],
      mount: translateEl,
      isMobile,
    });
  }
};

export { translateBrooklyn };
